import React from "react";
import { Link } from "react-router-dom";
import { useCookiesContext } from "../contexts/CookiesContext";
import { footerTranslates } from "@revbox/localization";
export default function Footer() {
  const { getLanguageAbbr } = useCookiesContext()
  const languageAbbr = getLanguageAbbr()

  return (
    <div className="main-footer main-footer-bottom mb-4">
      <span>&copy; {new Date().getFullYear()}. Revbox. {footerTranslates[languageAbbr]}.</span>
    </div>
  )
}